import { render, staticRenderFns } from "./classification.vue?vue&type=template&id=51f3d668&"
import script from "./classification.vue?vue&type=script&lang=js&"
export * from "./classification.vue?vue&type=script&lang=js&"
import style0 from "./classification.vue?vue&type=style&index=0&id=51f3d668&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports